export const GET_CURRICULUM = 'GET_CURRICULUM'
export const GET_CURRICULUM_SUCCESS = 'GET_CURRICULUM_SUCCESS'
export const GET_CURRICULUM_ERROR = 'GET_CURRICULUM_ERROR'

export interface Curriculum {
  id: string
  nombre: string
  fotoURL: string
}

export interface CurriculumRecomendado {
  id: number
  nombre: string
  email: string
  fechaNacimiento: string
  estadoCivil: string
  paisNacimiento: string
  paisResidencia: string
  telefonoCelular: number
  telefonoFijo: number
  direccion: string
  fotoURL: string
  adjuntoURL: string
  estudios
  experienciasLaborales
  conocimientosNormalizados
  conocimientosDesnormalizados
  tipoDocumento: string
  salarioPreferencia: number
  descripcion: string
  documento: string
  resumenPDA
  tienePerfilPDA: boolean
}


export interface GetCurriculum {
  type: typeof GET_CURRICULUM
  payload: null
}

export interface GetCurriculumSuccess {
  type: typeof GET_CURRICULUM_SUCCESS
  payload: Curriculum
}


export interface GetCurriculumRecomendadoSuccess {
  type: typeof GET_CURRICULUM_SUCCESS
  payload: CurriculumRecomendado
}

export interface GetCurriculumError {
  type: typeof GET_CURRICULUM_ERROR
  payload: boolean
}

export interface CurriculumState {
  curriculum: Curriculum | null
  loading: boolean
  error: boolean
}

export const InitialStateCurriculum: CurriculumState = {
  curriculum: null,
  loading: true,
  error: false,
}

export type CurriculumActions = GetCurriculum | GetCurriculumSuccess | GetCurriculumRecomendadoSuccess | GetCurriculumError
